/**
 * DAOmotion landing checkout — version cards, data path, kit reveal, add to cart.
 */
(function () {
  function moneyFromCents(cents, currency) {
    var n = Number(cents) / 100;
    if (Number.isNaN(n)) return "";
    return new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" }).format(n) + " " + (currency || "USD");
  }

  function parseVariantJson(checkoutId) {
    var el = document.getElementById("VariantJson-" + checkoutId);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function updatePrice(checkoutId, variant) {
    var box = document.getElementById("ProductPrice-" + checkoutId);
    if (!box || !variant) return;
    var sale = box.querySelector("[data-price-sale]");
    if (sale) {
      sale.textContent = variant.price_formatted || moneyFromCents(variant.price, box.dataset.currency);
    }
    var btn = document.querySelector(
      '[data-checkout-form="' + checkoutId + '"] [data-add-button]'
    );
    var label = btn && btn.querySelector("[data-add-label]");
    if (btn) {
      btn.disabled = !variant.available;
    }
    if (label) {
      label.textContent = variant.available ? "Order Now" : "Sold out";
    }
  }

  function selectVariant(checkoutId, variantId) {
    var select = document.getElementById("ProductSelect-" + checkoutId);
    if (!select) return;
    select.value = String(variantId);
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function matchVariant(variants, needle) {
    if (!needle) return null;
    var n = String(needle).toLowerCase();
    return (
      variants.find(function (v) {
        return String(v.title).toLowerCase().indexOf(n) !== -1;
      }) || null
    );
  }

  function scrollToOrder() {
    var target = document.getElementById("order") || document.getElementById("pre-order");
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function getSelectedVersionKey() {
    var selected = document.querySelector("[data-version-card].is-selected");
    if (selected && selected.getAttribute("data-kit-version")) {
      return selected.getAttribute("data-kit-version");
    }
    var select = document.querySelector("[data-variant-select]");
    if (select && select.tagName === "SELECT") {
      var opt = select.options[select.selectedIndex];
      var title = (opt && opt.textContent) || "";
      if (/floating/i.test(title)) return "floating";
      if (/fixed/i.test(title)) return "fixed";
    }
    return "";
  }

  function getSelectedDataPath() {
    var checked = document.querySelector("[data-data-path]:checked");
    return checked ? checked.value : "";
  }

  function syncDataPathField() {
    document.querySelectorAll("[data-signal-panel]").forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-signal-panel") !== getSelectedDataPath();
    });
    var value = getSelectedDataPath();
    document.querySelectorAll("[data-data-path-field]").forEach(function (field) {
      field.value = value;
    });
  }

  function updateKitPanel() {
    var version = getSelectedVersionKey();
    var data = getSelectedDataPath();
    var ready = !!version && !!data;

    var panel = document.querySelector("[data-kit-panel]");
    var hint = document.querySelector("[data-kit-hint]");
    var prompt = document.querySelector("[data-kit-prompt]");
    var grid = document.querySelector("[data-kit-grid]");

    if (panel) {
      panel.classList.toggle("is-ready", ready);
    }

    if (hint) {
      hint.textContent = ready
        ? version === "floating"
          ? "Floating · " + data
          : "Fixed · " + data
        : "Choose a version and data option first";
    }

    if (prompt) prompt.hidden = ready;
    if (grid) grid.hidden = !ready;

    document.querySelectorAll("[data-kit-item]").forEach(function (item) {
      var key = item.getAttribute("data-kit-item");
      var show = false;
      if (ready) {
        if (key === "hub-floating") show = version === "floating";
        if (key === "hub-fixed") show = version === "fixed";
        if (key === "data-obd2") show = /obd2/i.test(data);
        if (key === "data-flexible") show = /flexible/i.test(data);
      }
      item.hidden = !show;
    });
  }

  function bindSelect(select) {
    var checkoutId = select.getAttribute("data-checkout-id");
    if (!checkoutId) return;
    var variants = parseVariantJson(checkoutId);

    select.addEventListener("change", function () {
      var id = Number(select.value);
      var variant = variants.find(function (v) {
        return Number(v.id) === id;
      });
      updatePrice(checkoutId, variant);
      document.querySelectorAll("[data-version-card]").forEach(function (card) {
        var key = (card.getAttribute("data-variant-match") || "").toLowerCase();
        var active =
          variant &&
          String(variant.title).toLowerCase().indexOf(key) !== -1;
        card.classList.toggle("is-selected", !!active);
        card.setAttribute("aria-pressed", String(!!active));
      });
      updateKitPanel();
    });

    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function bindVersionCards() {
    document.querySelectorAll("[data-version-card]").forEach(function (card) {
      card.addEventListener("click", function () {
        var checkoutId = card.getAttribute("data-checkout-id");
        var match = card.getAttribute("data-variant-match");
        var variants = parseVariantJson(checkoutId);
        var variant = matchVariant(variants, match);
        if (variant) {
          selectVariant(checkoutId, variant.id);
        } else {
          document.querySelectorAll("[data-version-card]").forEach(function (c) {
            c.classList.toggle("is-selected", c === card);
            c.setAttribute("aria-pressed", String(c === card));
          });
          updateKitPanel();
        }
        var step = document.querySelector('[data-theme-preview]');
        if (step) step.scrollIntoView({behavior:'smooth',block:'start'}); else scrollToOrder();
      });
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          card.click();
        }
      });
    });
  }

  function bindDataPath() {
    document.querySelectorAll("[data-data-path]").forEach(function (input) {
      input.addEventListener("change", function () {
        syncDataPathField();
        updateKitPanel();
      });
    });
    syncDataPathField();
    updateKitPanel();
  }

  function bindOrderLinks() {
    document.querySelectorAll('a[href="#order"], a[href="#pre-order"]').forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        scrollToOrder();
        history.replaceState(null, "", "#order");
      });
    });
  }

  function bindAddToCartForms() {
    var isLocalPreview = /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);

    document.querySelectorAll(".dm-product-form.dm-lp-checkout__form").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        if (window.dmSelectionReady && !window.dmSelectionReady()) { e.preventDefault(); return; }
        var boltField = form.querySelector('[data-bolt-pattern]');
        if (boltField && (!boltField.reportValidity() || !["70 mm", "74 mm"].includes(boltField.value))) { e.preventDefault(); boltField.focus(); return; }
        var vehicleProperties = window.dmVehicleProperties(form);
        if (!vehicleProperties) { e.preventDefault(); return; }
        var themeField = form.querySelector('[data-order-theme]');
        if (themeField && !themeField.value) { e.preventDefault(); document.querySelector('[data-theme-preview]').scrollIntoView({behavior:'smooth'}); document.querySelector('[data-theme-confirm]').focus({preventScroll:true}); return; }
        if (isLocalPreview) {
          e.preventDefault();
          window.alert(
            "Local preview cannot add to Shopify cart. Upload the theme and create products in Shopify Admin, then Order Now will add the item and take you to the cart."
          );
          return;
        }

        e.preventDefault();
        syncDataPathField();

        var variantField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        var returnField = form.querySelector('[name="return_to"]');
        var dataField = form.querySelector('[name="properties[Data]"]');
        var variantId = variantField && variantField.value;
        var quantity = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
        var cartUrl = (returnField && returnField.value) || "/cart";
        var btn = form.querySelector("[data-add-button]");
        var label = btn && btn.querySelector("[data-add-label]");
        var defaultLabel = label ? label.textContent : "Order Now";

        if (!variantId) return;

        if (btn) btn.disabled = true;
        if (label) label.textContent = "Adding...";

        var payload = {
          id: Number(variantId),
          quantity: quantity,
          properties: {
            Data: (dataField && dataField.value) || getSelectedDataPath() || "OBD2",
          },
        };

        Object.assign(payload.properties, vehicleProperties);
        if (themeField) payload.properties['Display theme'] = themeField.value;
        if (boltField) payload.properties['Bolt pattern'] = boltField.value;
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (body) {
                throw body;
              });
            }
            return response.json();
          })
          .then(function () {
            window.location.href = cartUrl;
          })
          .catch(function (err) {
            if (btn) btn.disabled = false;
            if (label) label.textContent = defaultLabel;
            var message =
              (err && (err.description || err.message)) ||
              "Could not add this item to your cart. Please try again.";
            window.alert(message);
          });
      });
    });
  }

  function init() {
    document.querySelectorAll("[data-variant-select]").forEach(bindSelect);
    bindVersionCards();
    bindDataPath();
    bindOrderLinks();
    bindAddToCartForms();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
